import React from "react";
import PropTypes from "prop-types";

export function FrontSection(props) {
  return (
    <div
      className={props.className}
      role="button"
      tabIndex="0"
      onClick={props.onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          props.onClick;
        }
      }}
    />
  );
}

FrontSection.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * callback function to trgger on click
   */
  onClick: PropTypes.func,
};

FrontSection.defaultProps = {
  className: "",
};
